import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'src/components/queryProvider';
import { TAKEOVER_CONFIG } from 'src/constants/gcfSectionConfig';
import { ITakeoverSectionPayload } from 'src/interfaces';
import { queryKeys, requestCCApi } from 'src/utils';

import { getOrCreateSectionId } from './useCreateScreenSection';

const createTakeoverSection = async (payload: ITakeoverSectionPayload) => {
  const fullScreenSection = {
    height: payload.screen.height,
    width: payload.screen.width,
  };
  const sectionID = await getOrCreateSectionId(fullScreenSection);

  let screenID = payload.screen.id;

  await requestCCApi({
    url: '/screenSections',
    method: 'POST',
    data: {
      data: {
        section_id: sectionID,
        left_offset: 0,
        top_offset: 0,
        config: TAKEOVER_CONFIG,
        screen_id: screenID,
      },
    },
  });
};

export const useCreateTakeoverSection = () => {
  return useMutation({
    mutationFn: createTakeoverSection,
    onSuccess: () => {
      queryClient.invalidateQueries(queryKeys.screenSections.invalidateAll());
    },
  });
};
